module.exports = __webpack_public_path__ + "static/img/view-02-sub@t.d8ac61c.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/project-detail/ket/view-02-sub@t.jpg
// module id = DXkf
// module chunks = 0